import React from 'react'

const ACTIVE_CLASSES = {
  solid: 'bg-rb-green text-white dark:text-rb-dark-mode',
  soft: 'bg-rb-light-green dark:bg-rb-green/15 text-rb-black dark:text-white ring-1 ring-inset ring-rb-green'
}

export default function SegmentedControl({ options, isActive, onSelect, size = 'md', variant = 'solid', className = '' }) {
  const sizeClasses = size === 'sm' ? 'h-9 text-sm' : 'h-11 text-sm'

  return (
    <div className={`inline-flex items-stretch rounded-lg border-1 border-rb-lite-grey dark:border-rb-dark-mode-lighter bg-white dark:bg-rb-dark-mode p-0.5 ${sizeClasses} ${className}`}>
      {options.map(option => {
        const active = isActive(option.value)
        return (
          <button
            key={option.value}
            type="button"
            title={option.title}
            onClick={() => onSelect(option.value)}
            className={`flex items-center justify-center gap-1.5 min-w-[2.5rem] px-3 rounded-md font-medium transition-colors ${active ? ACTIVE_CLASSES[variant] : 'text-rb-mat-grey dark:text-gray-400 hover:bg-rb-grey dark:hover:bg-rb-dark-mode-lighter'}`}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  )
}
